export function curatedMarketingDisclosureCB() {
return [   // Release 2026-06-29 14:16:43
 
{
   page: 0,
   name: "Text1", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 613.621,
   left: 222.892,
   width: 49.854,
   height: 14.145
}
,
{
   page: 0,
   name: "Text2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 613.621,
   left: 274.947,
   width: 49.854,
   height: 14.145
}
,
{
   page: 1,
   name: "Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 550.582,
   left: 139.909,
   width: 404.509,
   height: 13.491
}
,
{
   page: 1,
   name: "Text3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 84.164,
   left: 210.765,
   width: 48.545,
   height: 13.491
}
,
{
   page: 1,
   name: "Text4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 84.164,
   left: 264.42,
   width: 48.545,
   height: 13.491
}
,
{
   page: 1,
   name: "Text5", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 200.746,
   left: 143.001,
   width: 48.545,
   height: 13.491
}
,
{
   page: 1,
   name: "Text6", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 200.746,
   left: 193.401,
   width: 48.545,
   height: 13.491
}
,
{
   page: 1,
   name: "Text7", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 347.056,
   left: 206.183,
   width: 48.545,
   height: 13.491
}
,
{
   page: 1,
   name: "Text8", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 346.401,
   left: 259.201,
   width: 48.545,
   height: 13.491
}
,
{
   page: 1,
   name: "Signature Seller 1 Name", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 593.475,
   left: 48.4366,
   width: 155.2364,
   height: 13.491
}
,
{
   page: 1,
   name: "Date Signature Seller1 Name", 
   fontSize: 9,
   type: "date",
   top: 593.475,
   left: 205.946,
   width: 64.255,
   height: 13.491
}
,
{
   page: 1,
   name: "Signature Seller 2 Name", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 593.13,
   left: 296.656,
   width: 178.145,
   height: 13.491
}
,
{
   page: 1,
   name: "Date Signature Seller2 Name", 
   fontSize: 9,
   type: "date",
   top: 593.475,
   left: 477.82,
   width: 63.60,
   height: 13.491
}
,
{
   page: 1,
   name: "Signature Seller Broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 651.73,
   left: 49.7457,
   width: 161.1273,
   height: 13.491
}
,
{
   page: 1,
   name: "Date Signature Seller Broker", 
   fontSize: 9,
   type: "date",
   top: 651.73,
   left: 215.346,
   width: 71.455,
   height: 13.491
}
,
{
   page: 1,
   name: "Text15", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 389.838,
   left: 268.674,
   width: 48.545,
   height: 13.491
}
,
{
   page: 1,
   name: "Text16", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 389.838,
   left: 322.383,
   width: 48.545,
   height: 13.491
}
] }
